var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00001 6C8.53044 6 9.03915 6.21071 9.41422 6.58579C9.78929 6.96086 10 7.46957 10 8C10 8.53043 9.78929 9.03914 9.41422 9.41421C9.03915 9.78929 8.53044 10 8.00001 10C7.46957 10 6.96086 9.78929 6.58579 9.41421C6.21072 9.03914 6.00001 8.53043 6.00001 8C6.00001 7.46957 6.21072 6.96086 6.58579 6.58579C6.96086 6.21071 7.46957 6 8.00001 6ZM8.00001 3C11.3333 3 14.18 5.07333 15.3333 8C14.18 10.9267 11.3333 13 8.00001 13C4.66667 13 1.82001 10.9267 0.666672 8C1.82001 5.07333 4.66667 3 8.00001 3ZM2.12001 8C2.65884 9.1002 3.49554 10.0272 4.53499 10.6755C5.57444 11.3238 6.77494 11.6675 8.00001 11.6675C9.22507 11.6675 10.4256 11.3238 11.465 10.6755C12.5045 10.0272 13.3412 9.1002 13.88 8C13.3412 6.8998 12.5045 5.97283 11.465 5.3245C10.4256 4.67616 9.22507 4.33245 8.00001 4.33245C6.77494 4.33245 5.57444 4.67616 4.53499 5.3245C3.49554 5.97283 2.65884 6.8998 2.12001 8Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/View.f8d71e9786e1eb238df413981a48e76f.svg";
export { ForwardRef as ReactComponent };